import { SourcingChannelDetails } from 'api-clients/monolith';
import _range from 'lodash/range';
import { FormattedMessage } from 'react-intl';

import { Skeleton } from '@/components/ui/skeleton';
import { Typography } from '@/components/ui/typography';

import { InactiveChannelCard } from './card';

interface InactiveChannelsProps {
  channels: SourcingChannelDetails[];
  openingId?: string;
}

export function InactiveChannels({
  channels,
  openingId,
}: InactiveChannelsProps) {
  // Show a placeholder when there are no channels to add some padding to the section
  if (channels.length === 0) {
    return <div className="min-h-2 flex" />;
  }

  return (
    <>
      <Typography as="h2" variant="caption">
        <FormattedMessage
          defaultMessage="Other channels"
          description="Section heading for add-on boards not in the main grid"
        />
      </Typography>
      <div className="flex min-h-[228px] flex-row gap-4 overflow-x-auto whitespace-normal pb-2">
        {channels.map(channel => (
          <InactiveChannelCard
            key={channel.slug}
            channel={channel.slug}
            openingId={openingId}
          />
        ))}
      </div>
    </>
  );
}

InactiveChannels.Skeleton = function InactiveChannelsSkeleton() {
  return (
    <>
      <Skeleton className="h-3 w-40 shrink-0" />
      <div className="flex min-h-[228px] flex-row gap-4 overflow-x-auto whitespace-normal pb-2">
        {_range(3).map(index => (
          <InactiveChannelCard.Skeleton key={`skeleton-${index}`} />
        ))}
      </div>
    </>
  );
};
